import { motion } from "framer-motion"
import { useMemo } from "react"

interface Star {
  id: number
  x: number
  y: number
  size: number
  twinkleDuration: number
  floatDuration: number
}

export function FloatingStars({ count = 40 }: { count?: number }) {
  const stars = useMemo<Star[]>(
    () =>
      Array.from({ length: count }, (_, i) => ({
        id: i,
        x: Math.random() * 100,
        y: Math.random() * 100,
        size: Math.random() * 2 + 1,
        twinkleDuration: Math.random() * 2 + 1,
        floatDuration: Math.random() * 10 + 10,
      })),
    [count]
  )

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        pointerEvents: "none",
        zIndex: 0,
      }}
    >
      {stars.map((star) => (
        <motion.div
          key={star.id}
          animate={{
            opacity: [0.3, 1, 0.3],
            y: [0, -10, 0],
          }}
          transition={{
            opacity: { duration: star.twinkleDuration, repeat: Infinity },
            y: { duration: star.floatDuration, repeat: Infinity, ease: "easeInOut" },
          }}
          style={{
            position: "absolute",
            left: `${star.x}%`,
            top: `${star.y}%`,
            width: star.size,
            height: star.size,
            background: "#7c5cf6",
            borderRadius: "50%",
            boxShadow: `0 0 ${star.size * 2}px #7c5cf6`,
          }}
        />
      ))}
    </div>
  )
}
